module.exports = __webpack_public_path__ + "img/car4.aa77e4a6.png";